
/*
 * @Description: 卡片内展示行信息 eg:下单页面
 */

<template  minapp='mpx' xlang='wxml'>
  <view class="info-content" wx:class="{{ hasBottomMargin ? 'bottom':''}}" bindtap="didClick">
    <text class="title">{{ title }}</text>
    <slot wx:if="{{useSlot}}"/>
    <text wx:else class="value" wx:style="{{valueStyle}}">{{ value }}</text>
    <es-icon wx:if="{{hasArrow}}" class="arrow" name="angle-right" size="20" color="#999999" />
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      },
      value: {
        type: String,
        value: ''
      },
      hasBottomMargin: {
        type: Boolean,
        value: true
      },
      hasArrow: {
        type: Boolean,
        value: false
      },
      useSlot: {
        type: Boolean,
        value: false
      },
      valueStyle: {
        type: Object,
        value: {}
      }
    },
    data: {},
    watch: {},
    computed: {},
    methods: {
      didClick() {
        this.$trigger('click', null)
      }
    },
    beforeCreate() {},

    created() {},

    mounted() {},

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  .info-content
    display flex
    justify-content flex-start
    font-size 14px
  .bottom
    margin-bottom 12px
  .title
    flex 0 0 70px
    color #999999
  .value
    flex 1
    color #333333
    white-space pre-wrap
  .arrow
    margin-left auto
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {}
  }
</script>